function isWhitespace(ch: string) {
    return ch === " " || ch === "\n"
}

export function trimeSelectionRange(q: any, range: { index: number; length: number }) {
    let start = range.index;
    let end = range.index + range.length;

    while (start < end) {
        const ch = q.getText(start, 1);
        if (!isWhitespace(ch)) break
        start++;
    }

    while (end > start) {
        const ch = q.getText(end - 1, 1);
        if (!isWhitespace(ch)) break;
        end--;
    }

    return { index: start, length: (end - start) }
}


function trimeDeltaSpace(q: any, range: { index: number; length: number }) {
    let start = range.index;
    let end = range.index + range.length;

    while (start < end) {
        const ch = q.getText(start, 1);
        if (!isWhitespace(ch)) break
        start++;
    }

    while (end > start) {
        const ch = q.getText(end - 1, 1);
        if (!isWhitespace(ch)) break;
        end--;
    }

    return q.getContents(start, end-start)
}